export const commonCrudOption = {
  // table配置
  border: true,
  stripe: true,
  align: 'center',
  size: 'mini',
  height: '100%',

  // 索引
  index: true,
  indexLabel: '序号',
  indexWidth: 60,

  // 搜索按钮折叠
  searchIndex: 3,
  searchIcon: false,
  searchBtnIcon: 'none',
  searchSpan: 4,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  searchMenuPosition: 'right',
  emptyBtnText: '重置',
  emptyBtnIcon: 'none',
  menuRight: false,
  menuLeft: false,

  // 操作栏
  menuAlign: 'center',
  addBtn: false,
  // 操作栏按钮
  viewBtn: false,
  editBtn: false,
  editBtnIcon: 'none',
  delBtn: false,
  delBtnIcon: 'none',

  // 弹窗配置
  dialogType: 'drawer',
  dialogDirection: 'rtl',
  dialogClickModal: false,
  span: 24,
  dialogWidth: 800
}
